export enum IssueType {
  Bug = 'Bug',
  Feature = 'Feature',
  Support = 'Support',
  Auto = 'Auto',
}

export enum ContactType {
  Email = 'Email',
  Telegram = 'Telegram',
  Discord = 'Discord',
  Phone = 'Phone',
}

export interface Report {
  reportType: IssueType;
  summary: string; // Summary of the issue
  description?: string;

  userAddress?: string;
  msafeAddress?: string;
  stack?: string;

  contactType: ContactType;
  contact: string;
}
